import { render, staticRenderFns } from "./EmbeddedSocialMediaReviewPc.vue?vue&type=template&id=7ec35e15&scoped=true"
import script from "./EmbeddedSocialMediaReviewPc.vue?vue&type=script&lang=js"
export * from "./EmbeddedSocialMediaReviewPc.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedSocialMediaReviewPc.vue?vue&type=style&index=0&id=7ec35e15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec35e15",
  null
  
)

export default component.exports